import type { Merchant } from '~entities/merchant';

import type { AbstractOption } from '~shared/types/abstract-options';

export const getMerchantsOptions = (
  merchants: Merchant[]
): AbstractOption<string>[] => {
  return merchants.map(({ id, name }) => ({
    value: id,
    title: name,
    checkmarkStyle: 'checkbox',
  }));
};
